import React from 'react'
import DateFormat from '../../../shared/helpers/date-format'

let { timeSimple, timeMeridian } = DateFormat

const Hours = ({ time, type }) => {
  let at = typeof time === 'string' ? new Date(time) : time

  return (
    <dl className="bg-black-4 m-1 text-depths">
      <dt className="text-18 xl:text-24 lg:m-1 lg:mr-0 p-16 pb-0 lg:p-20 lg:w-180-fixed">
        <span className="sr-only">At</span>
        <time className="font-bold">
          {timeSimple(at)}
          <span className="text-12">{timeMeridian(at)}</span>
        </time>
      </dt>

      <dd className="flex mb-1">
        <div className="m-1 hidden lg:block lg:w-180-fixed flex-shrink-0" />
        <div className="m-1 p-16 lg:px-24 leading-normal flex-grow">
          <h2>Doors {type}</h2>
        </div>
      </dd>
    </dl>
  )
}

export default Hours
